import { AncillaryRadioGroup, Text, textVariants, ValidationMessage } from '@etg/wings';
import { ScreenReaderPrice } from '@eti/components';
import { css } from '@eti/styles';
import { priceLabelStyles, priceStyles, standardGrid } from '../../common/main-layout/cta-components/styles';
import { NoneOption } from './utils';
import { OperatorCardStandalone } from './OperatorCard';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const selectionWrapperStyles = css`
  grid-area: 3 / 2 / 4 / 3;
`;
const singleOperatorCtaStyles = css`
  ${standardGrid}
  grid-area: 4 / 2 / 5 / 3;
`;
const SingleOperatorSelection = ({
  input,
  handleChange,
  meta,
  operator,
  productName,
  translation,
  labelNo,
  labelYes,
  selectOneLabel,
  handleOpenDrawer
}) => {
  const hasError = meta.touched && (Boolean(meta.error) || input.value === undefined);
  const declineOption = {
    'data-testid': `${productName}--false`,
    id: `${productName}_false`,
    label: labelNo,
    value: NoneOption
  };
  const acceptOption = {
    'data-testid': `${productName}--true`,
    id: `${productName}_true`,
    label: labelYes,
    value: String(operator.externalChoiceId)
  };
  const options = [declineOption, acceptOption];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: selectionWrapperStyles,
      children: /*#__PURE__*/_jsx(OperatorCardStandalone, {
        handleOpenDrawer: handleOpenDrawer,
        operator: operator,
        translation: translation
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: singleOperatorCtaStyles,
      children: [/*#__PURE__*/_jsx("div", {
        className: `${priceLabelStyles} priceLabel`,
        children: /*#__PURE__*/_jsx(Text, {
          children: translation.perPerson
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: `${priceStyles} price`,
        children: [/*#__PURE__*/_jsx(Text, {
          "aria-hidden": true,
          "data-testid": "operator-price",
          variant: textVariants._18_EMPHASIZED,
          children: operator.price
        }), /*#__PURE__*/_jsx(ScreenReaderPrice, {
          price: operator.price
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "buttonWrapper",
        children: /*#__PURE__*/_jsx(AncillaryRadioGroup, {
          "data-testid": "radioToggle-ancillary-radio-group",
          hasError: hasError,
          legend: selectOneLabel,
          name: input.name,
          onChange: e => {
            handleChange(e);
            input.onChange(e);
          },
          options: options,
          selectedValue: String(input.value)
        })
      }), hasError && /*#__PURE__*/_jsx(ValidationMessage, {
        className: "validation",
        "data-testid": "airport-transfer-validation",
        role: "alert",
        variant: "error",
        children: meta.error
      })]
    })]
  });
};
export default SingleOperatorSelection;
//# sourceMappingURL=SingleOperatorSelection.js.map